import { createApp } from 'vue';
import './assets/main.css';
import App from './App.vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import '@fortawesome/fontawesome-free/css/all.css';
import { createHead } from '@vueuse/head';
const app = createApp(App);
const head = createHead();
app.use(head);


// import Lenis from 'lenis';

gsap.registerPlugin(ScrollTrigger);


function raf(time) {
  // lenis.raf(time);
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

app.mount('#app');
